import cx from 'classnames'
import Styles from './PlanDetails.module.scss'

import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { Text } from 'blaze-ui/Text/Text'
import {
  Approval,
  ArrowRight,
  Brand,
  ColumnVertical1,
  CopyRight2,
  Design,
  Gift01,
  Knowledge,
  Lightbulb1,
  // Plus,
  Send1,
  Shuffle,
  Target2,
  TemplatesFilled,
  UserProfileCircle,
  UsersProfiles1,
} from 'blaze-ui/icons'
import { Server02 } from 'blaze-ui/icons/16/Server02'
import { LineChartUp01 } from 'blaze-ui/icons/16/LineChartUp01'
import { Email } from 'blaze-ui/icons/24'

import { Headphones } from 'blaze-ui/icons/24/Headphones'
import { useReferralUrl } from 'components/Settings/ReferralModalV2/hooks/useReferralUrl'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { Button } from 'blaze-ui/Button'
import { FacebookBrand } from 'blaze-ui/icons/35'
import { LinkedInBrand } from 'blaze-ui/icons/32'
import { IconButtonLink } from 'blaze-ui/IconButton/IconButtonLink'
import { useModals } from 'almanac-ui/Modal'
import { ReferralModalV2 } from 'components/Settings/ReferralModalV2/ReferralModalV2'
import { FREE_REWARD_TIERS } from 'hooks/useAutopilotLimits'

export const TwitterX = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <path
        fill="#15171A"
        fillRule="evenodd"
        d="M12.14 2.57 8.67 6.62 5.9 2.57H2.06l4.48 6.55L2 14.43h1.56l3.67-4.29 2.93 4.3H14l-4.63-6.8 4.33-5.07h-1.56Zm-1.29 10.71L7.97 9.13 4.24 3.75h.96l6.62 9.53h-.97Z"
        clipRule="evenodd"
      />
    </svg>
  )
}

// const AddOns = () => {
//   return (
//     <div className={Styles.addOnsContainer}>
//       <div className={Styles.addOnsHeader}>
//         <Text variant="label" color="var(--dark-80)">
//           Add-ons to purchase:
//         </Text>
//       </div>
//       <div className={Styles.addOns}>
//         <Button frontIcon={Plus} variant="ghost">
//           100 Add-on Credits
//         </Button>
//         <Button frontIcon={Plus} variant="ghost">
//           Add-on Channels
//         </Button>
//         <Button frontIcon={Plus} variant="ghost">
//           Enable White Label
//         </Button>
//       </div>
//     </div>
//   )
// }

export const FeatureList = ({ plan, currentPlan }: { plan: PaymentPlanKey; currentPlan: PaymentPlanKey }) => {
  const { openModal } = useModals()
  const { referralUrl } = useReferralUrl()
  const encodedReferralUrl = encodeURIComponent(referralUrl)
  const twitterPrefillText = encodeURIComponent(
    `Hey, I’ve been using @blazeaiapp to save 10+ hours a week, and it’s been a game-changer. Try it for free with my link: ${referralUrl}.`,
  )

  const colorMap: any = {
    [PaymentPlanKey.Free]: '#949494',
    [PaymentPlanKey.BlazeAutopilotStarter]: '#F6A11A',
    [PaymentPlanKey.BlazeAutopilotGrowth]: 'var(--blue-50)',
    [PaymentPlanKey.BlazeAutopilotEnterprise]: '#9935F5',
  }
  const color = colorMap[plan]

  const generationCreditsMap: any = {
    [PaymentPlanKey.BlazeAutopilotStarter]: '800',
    [PaymentPlanKey.BlazeAutopilotGrowth]: '2000',
  }
  const generationCredits = generationCreditsMap[plan]

  // const showAddOns =
  //   (plan === PaymentPlanKey.BlazeAutopilotStarter && currentPlan === PaymentPlanKey.BlazeAutopilotStarter) ||
  //   (plan === PaymentPlanKey.BlazeAutopilotGrowth && currentPlan === PaymentPlanKey.BlazeAutopilotGrowth)

  return (
    <>
      {/*{showAddOns && <AddOns />}*/}
      <div className={Styles.featureList}>
        {plan === PaymentPlanKey.Free && (
          <>
            <div className={Styles.feature}>
              <TemplatesFilled size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>3</strong> posting channels (with Blaze Watermark)
              </Text>
            </div>
            <div className={Styles.feature}>
              <Send1 size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>{FREE_REWARD_TIERS[0]}</strong> post/week per channel
              </Text>
            </div>
          </>
        )}
        {plan === PaymentPlanKey.BlazeAutopilotStarter && currentPlan === PaymentPlanKey.BlazeAutopilotStarter && (
          <>
            <Text variant="label" color="var(--dark-80)">
              Everything in Free plus:
            </Text>
            <div className={Styles.feature}>
              <TemplatesFilled size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>3</strong> posting channels (no watermark)
              </Text>
            </div>
            <div className={Styles.feature}>
              <Send1 size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>Unlimited</strong> posts/week
              </Text>
            </div>
            <div className={Styles.feature}>
              <Server02 color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>{generationCredits}</strong> generation credits
              </Text>
            </div>
          </>
        )}
        {plan === PaymentPlanKey.BlazeAutopilotStarter && currentPlan !== PaymentPlanKey.BlazeAutopilotStarter && (
          <>
            <Text variant="label" color="var(--dark-80)">
              Everything in Free plus:
            </Text>
            <div className={Styles.feature}>
              <TemplatesFilled size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>3</strong> posting channels (no watermark)
              </Text>
            </div>
            <div className={Styles.feature}>
              <Server02 color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>{generationCredits}</strong> generation credits
              </Text>
            </div>
            <div className={Styles.feature}>
              <Send1 size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>Unlimited</strong> posts/week
              </Text>
            </div>
            <div className={Styles.feature}>
              <UserProfileCircle size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>1 seat</strong>
              </Text>
            </div>
            <div className={Styles.feature}>
              <Brand size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                Brand Kit (voice, logo, colors, fonts)
              </Text>
            </div>
            <div className={cx(Styles.feature, Styles.knowledge)}>
              <Knowledge size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                AI learning loops
              </Text>
            </div>
            <div className={Styles.feature}>
              <LineChartUp01 size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)" lineClamp={1}>
                Content insights & analytics
              </Text>
            </div>
          </>
        )}
        {plan === PaymentPlanKey.BlazeAutopilotGrowth && (
          <>
            <Text variant="label" color="var(--dark-80)">
              Everything in Starter plus:
            </Text>
            <div className={Styles.feature}>
              <TemplatesFilled size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>10</strong> posting channels
              </Text>
            </div>
            <div className={Styles.feature}>
              <Server02 color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>{generationCredits}</strong> generation credits
              </Text>
            </div>
            <div className={Styles.feature}>
              <UserProfileCircle size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>Unlimited</strong> seats
              </Text>
            </div>
            <div className={Styles.feature}>
              <ColumnVertical1 size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>Parallel campaigns</strong>
              </Text>
            </div>
            <div className={Styles.feature}>
              <Approval size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>Multi-user workflow</strong> (reviews, approvals)
              </Text>
            </div>
            <div className={Styles.feature}>
              <Target2 size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                AI-powered <strong>ad management</strong>
              </Text>
            </div>
            <div className={Styles.feature}>
              <Shuffle size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>Cross-posting</strong>
              </Text>
            </div>
          </>
        )}
        {plan === PaymentPlanKey.BlazeAutopilotEnterprise && (
          <>
            <Text variant="label" color="var(--dark-80)">
              Everything in Growth plus:
            </Text>
            <div className={Styles.feature}>
              <Lightbulb1 size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                Dedicated <strong>AI Strategy Expert</strong>
              </Text>
            </div>
            <div className={Styles.feature}>
              <Headphones size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                Personalized <strong>onboarding support</strong>
              </Text>
            </div>
            <div className={Styles.feature}>
              <Headphones size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>Custom</strong> integrations
              </Text>
            </div>
            <div className={Styles.feature}>
              <UsersProfiles1 size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>Group-based</strong> access controls (SSO/SAML)
              </Text>
            </div>
            <div className={Styles.feature}>
              <Brand size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                <strong>White-label</strong> interface
              </Text>
            </div>
            <div className={Styles.feature}>
              <Design size={16} color={color} />
              <Text variant="secondary" color="var(--dark-80)">
                Custom fonts, colors, and <strong>design systems</strong>
              </Text>
            </div>
          </>
        )}
      </div>
      {plan === PaymentPlanKey.Free && currentPlan === PaymentPlanKey.Free && (
        <div className={Styles.referralContainer}>
          <div className={Styles.referralHeader}>
            <div className={Styles.iconContainer}>
              <Gift01 color="var(--Magenta-70, #7F24B7)" />
            </div>
            <Text variant="smallList" color="var(--Magenta-70, #7F24B7)">
              Unlock more weekly posts — invite your friends!
            </Text>
          </div>
          <div className={Styles.referralUrlContainer}>
            <div className={Styles.textContainer}>
              <Text lineClamp={1} color="var(--dark-40)">
                {referralUrl}
              </Text>
            </div>
            <button
              onClick={() => {
                navigator.clipboard.writeText(referralUrl)
                showToastMessage('Referral URL copied!')
              }}
            >
              <CopyRight2 />
            </button>
          </div>
          <div className={Styles.footerContainer}>
            <div className={Styles.actions}>
              <Button
                frontIcon={Email}
                variant="tertiary"
                isDisabled={!referralUrl}
                onPress={() => openModal(ReferralModalV2)}
              >
                Email
              </Button>
              <IconButtonLink
                to={`https://www.facebook.com/sharer/sharer.php?u=${encodedReferralUrl}`}
                target="_blank"
                variant="tertiary"
                icon={() => <FacebookBrand size={20} />}
                isDisabled={!referralUrl}
              />
              <IconButtonLink
                to={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedReferralUrl}`}
                target="_blank"
                variant="tertiary"
                icon={() => <LinkedInBrand size={20} />}
                isDisabled={!referralUrl}
              />
              <IconButtonLink
                to={`https://twitter.com/intent/tweet?text=${twitterPrefillText}`}
                target="_blank"
                variant="tertiary"
                icon={TwitterX}
                isDisabled={!referralUrl}
              />
            </div>
            <Button variant="editor" endIcon={ArrowRight} fullWidth onPress={() => openModal(ReferralModalV2)}>
              Open Referrals
            </Button>
          </div>
        </div>
      )}
    </>
  )
}
